var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import Assembler from "./lib/objects/assembler";
import registration from "./lib/core/registration";
function start() {
    return __awaiter(this, void 0, void 0, function* () {
        const registry = yield registration();
        const assetManager = {};
        const assembler = new Assembler(assetManager);
        const data = yield assembler.assemble({
            apps: {
                type: "reference",
                path: 'game/index.json',
            },
            renderers: ["Toolbar"],
            assetManager,
        });
        data.appIndex = 0;
        data.apps.forEach((app, index) => {
            app.appIndex = index;
            if (app.entry) {
                data.appIndex = index;
            }
        });
        console.log(assembler.filesLoaded);
        registry.render(data);
    });
}
document.addEventListener("DOMContentLoaded", () => {
    start();
});
